<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1">For Edward C. Aswell, with gratitude<br/>for all the labor he did on this book</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?0a5f5182